<template>
  <div class="page page-history">
    <div class="chart">
      <ChartControls :timespan="timespan" @dateChange="onCalendarSelected" @timespanChange="onTimespanChanged" :showTimeSpan="true"
                     :showToday="true" :earliestChartMonth="EARLIEST_MONTH_DATE" />

      <div class="chart__container" v-if="!isCommunityLess">
        <DayChart v-if="timespan === 'day'" :key="timespan + '__day_chart'" v-model="chartData" />
        <MonthChart v-if="timespan === 'month'" :key="timespan + '__month_chart'" v-model="chartData" />
      </div>

      <div v-if="showCommunitylessHint" class="statistics__message">
        <p>{{ t(`global.communitylessHistoryHintConsumption.${timespan}`) }}</p>
        <p v-if="timespan == 'day'">{{ t("global.communitylessHistoryHintPrice") }}</p>
      </div>

      <div class="chart__limit-reached" v-if="timespan === 'day' && isFlexPlan && noFlexYet">
        Flexpreise für morgen stehen ab heute 18:00 Uhr zur Verfügung.
      </div>

      <div class="chart__prices-updating" v-show="pricesUpdating">
        <div class="chart__prices-updating-content">
          <IconSpinner :extra-classes="['chart__prices-updating-spinner']" />
        </div>
        {{ t('history.pricesUpdating') }}
      </div>

      <div class="chart__container" v-if="isLoaded && showPriceChart">
        <DayPriceChart v-if="isLoaded" v-model="chartData" />
      </div>
      <div v-if="isLoaded && hasProduction && !showPriceChart && isChartToday" class="statistics__message">
        Es wird keine Preiskurve angezeigt, weil für den aktuellen Einspeise-Tarif der Preis ein Monat im Nachhinein zur Verfügung steht.
      </div>

      <div class="chart__limit-reached" v-if="noEarlierMonthAvailable">
        Monatsdaten stehen ab
        {{ moment(EARLIEST_MONTH_DATE).format('MMMM YYYY') }} zur Verfügung.
      </div>

      <PowerStatistics v-if="isLoaded && !selectedDateInFuture" :timespan="timespan" v-model="chartData" />

      <div :class="overlayClasses">
        <IconSpinner :extra-classes="['chart__spinner']" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { toNative } from "vue-facing-decorator";
import Comp from "./PageHistory.ts";
import { computed } from "vue";

export default toNative(Comp);
</script>

<style lang="scss">
  .page-history {
    padding-bottom: 0;
    max-width: 1300px;
  }

  $controls-height: 2rem;

  .chart {
    &__container {
      height: 50vh;
      position: relative;

      @media (min-height: 320px) {
        margin-top: $spacer10;
      }

      @media (min-height: 400px) {
        height: 40vh;
        margin-top: $spacer20;
      }

      @media (min-height: 600px) {
        margin-top: $spacer30;
      }
    }

    &__canvas {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }

    &__controls {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      position: relative;
      z-index: 10;
      margin-top: $spacer05;
    }

    &__current {
      flex-basis: 100%;
      text-align: center;

      @media (min-height: 500px) {
        font-size: $font-size-lg;
      }
    }

    &__overlay {
      touch-action: none;
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      overflow: hidden;
      opacity: 0;
      background: rgba(255, 255, 255, 0.9);
      transition: opacity 0.5s, visibility 0s linear 0.6s;
      width: 100%;
      height: 100%;
      visibility: hidden;

      &--visible {
        opacity: 1;
        transition: opacity 0.3s;
        visibility: visible;

        .chart__spinner {
          animation: spin-centered 1.8s linear 0s infinite;
        }
      }
    }

    &__spinner {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 3rem;
      height: 3rem;
      color: $community;
    }

    &__limit-reached {
      margin-top: $spacer10;
      padding: $spacer10;
      background-color: $grey-light;
    }

    &__prices-updating {
      display: flex;
      align-items: center;
      gap: $spacer05;
      margin-top: $spacer10;
      font-size: $font-size-sm;
      color: $grey;
    }

    &__prices-updating-content {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 0.1rem;
      width: 1rem;
      margin-left: 0.5rem;
    }

    &__prices-updating-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      animation: spin-centered 1.8s linear 0s infinite;
    }
  }

</style>
